import React from 'react';
import styles from "./MapToolTip.module.scss";

const MapToolTip = ({top, left, name}) => {


    return ( 
            <div className = { styles.cityHover} style = {{top: top,left: left}} >
                <div className = {styles.cityHoverContainer } >
                    <span className = {styles.citynameHover} > {name}</span>
                </div> 
            </div>
        )
}

export default MapToolTip;